
import { append as append_1, choose, reduce, singleton as singleton_1, sumBy, collect, map as map_1, sum, tryFind, empty as empty_1, take, length, tryHead, contains, filter, ofArray, toArray, sortByDescending, exists, isEmpty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Permissions_allowsBooking, StorageAccess, Permissions_allowsObject, Permission, Permissions_allowsInStorage, Permissions_has } from "../../Shared/Roles.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { useTranslation } from "react-i18next";
import { usePermissions } from "../../UserPermissions.js";
import { reactElement, reactApi } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { toLocalTime, toString, compare, utcNow, date as date_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { DeleteReminder_OpenDialog, ConfirmDialog_ConfirmReminderDialog, EditReminder_OpenDialog, NewReminder_OpenDialog } from "../Dialog/AddReminderDialog.js";
import { parse } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { StorageId as StorageId_2, DocumentId__get_unwrap, ConsumableId as ConsumableId_1 } from "../../Shared/Shared.js";
import { Msg } from "./Types.js";
import { flatten, defaultArg, map, unwrap } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { defaultOf } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { TableControl$1, Table } from "../../Widgets/Table/Table.js";
import { ColoredDot } from "../../Components/ColoredDot.js";
import { ColumnDefinition$1, CellContent } from "../../Widgets/Table/Types.js";
import { stringHash, createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { split, concat, replace, join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import Calendar_Warning from "../../../public/assets/icons/Calendar_Warning.svg";
import { FileDialog_LinkedDocumentToolType, FileDialog_LinkedEntityId, Modal_OpenLinkedDocumentModalButtonModalSheet } from "../../Widgets/Modals/LinkedDocumentModal.js";
import { HistoryAccessProvider, OpenChangelogButtonModalSheet } from "../../Widgets/Modals/ChangelogModal.js";
import { Feature, isFeatureEnabled } from "../../FeatureFlip.js";
import Calendar_Add from "../../../public/assets/icons/Calendar_Add.svg";
import Pencil from "../../../public/assets/icons/Pencil.svg";
import Check from "../../../public/assets/icons/Check.svg";
import Recycle_Bin_1 from "../../../public/assets/icons/Recycle_Bin_1.svg";
import { TextDropdownButton, TextButton, Button } from "../../Components/Button.js";
import { ModalSheet } from "../../Components/ModalSheet.js";
import { NewReservation_NewConsumableReservationDialog } from "../Dialog/ReservationFormDialog.js";
import { EditConsumableReservationDialog } from "../Dialog/EditReservationFormDialog.js";
import { DeleteConsumableReservationDialog } from "../Dialog/DeleteReservationDialog.js";
import { targets, targetLabel, targetIcon, allows as allows_1, stateText, StateDot, useDefinitions, resolve } from "../../InventoryStates/Display.js";
import { ofConsumableState } from "../../Shared/InventoryStateMapping.js";
import { TextValue } from "../../Components/Text.js";
import { Helper_historyTypeToTranslationString, Helper_unitToTranslationKey } from "../../Shared/Consumable.js";
import { QuickOverviewList } from "../../Widgets/QuickOverviewList.js";
import { InventoryKind, InventoryAction } from "../../Shared/InventoryStates.js";
import Following from "../../../public/assets/icons/Following.svg";
import Followers from "../../../public/assets/icons/Followers.svg";
import { StartProcedureDialog } from "../../Widgets/Procedure/StartProcedureDialog.js";
import { ProcedureEntityReferenceDto } from "../../Shared/Procedure.js";
import { AssignConsumableDialog } from "../Dialog/AssignConsumableDialog.js";
import { UnassignConsumableDialog } from "../Dialog/UnassignConsumableDialog.js";
import { ReturnConsumableNotificationDialog } from "../Dialog/ReturnConsumableNotificationDialog.js";
import { SelfServiceAssignConsumableDialog } from "../Dialog/SelfServiceAssignConsumableDialog.js";
import { unwrapStorageId } from "../../Shared/Helper.js";
import { SelfServiceReturnConsumableDialog } from "../Dialog/SelfServiceReturnConsumableDialog.js";
import { StateChangeDialog } from "../Dialog/StateChangeDialog.js";
import Order_History from "../../../public/assets/icons/Order_History.svg";
import { NotificationArea } from "../../Widgets/Notification/NotificationArea.js";
import { NotificationToolType as NotificationToolType_1 } from "../../Widgets/Notification/AcceptNotificationDialog.js";
import { MultipleImageWidget } from "../../Widgets/Image/ImageWidget.js";
import { PropertyList } from "../../Widgets/PropertyListWidget.js";
import { CustomPropertiesPropertyList } from "../../Widgets/CustomPropertiesPropertyList.js";
import { getQueryParams, priceToString } from "../../Common.js";
import { DocumentTable } from "../../Widgets/Tables/DocumentTable.js";
import { UploadType as UploadType_2 } from "../../Widgets/Dialogs/FileUploadDialog.js";
import { Helper_displayHistoryComment } from "../../Shared/Changelog.js";
import { RouterModule_encodeQueryString, RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { AssignmentProtocolDialog, AssignmentProtocolParams } from "../../Widgets/AssignmentProtocol.js";
import { ChangeStockDialog } from "../Dialog/StockChangeDialog.js";
import { StockAddDialog } from "../Dialog/StockAddDialog.js";
import { ChangeStorageSpaceDialog } from "../Dialog/ChangeStorageSpaceDialog.js";
import { SwitchStorageDialog } from "../Dialog/SwitchStorageDialog.js";
import { MinimumStockQuantityDialog } from "../Dialog/MinimumStockQuantityDialog.js";
import { ConsumablesStockPerStorageDeleteDialog } from "../Dialog/ConsumableDeleteStockPerStorageDialog.js";
import Warehouse_1 from "../../../public/assets/icons/Warehouse_1.svg";
import Location_Building_Search from "../../../public/assets/icons/Location_Building_Search.svg";
import Transfer_Cart from "../../../public/assets/icons/Transfer_Cart.svg";
import Notification_Alarm_1 from "../../../public/assets/icons/Notification_Alarm_1.svg";
import { PrintLabelOptions, PrintLabelDialogFor, printLabelControl } from "../../Labels/PrintLabelsDialog.js";
import { QrCodeTableWithStorage } from "../../Widgets/Tables/QrCodeTable.js";
import { InventoryHistorySubject, InventoryStocktakingHistorySection, canReadStocktakingHistory } from "../../Widgets/StocktakingHistory.js";
import { LabelInventoryKind } from "../../Shared/Label.js";
import { ConsumableDeleteDialog } from "../Dialog/ConsumableDeleteDialog.js";
import { DetailViewHeader } from "../../Widgets/DetailViewHeader.js";
import { Badge } from "../../Components/Badge.js";
import { AreaAnchorMenu } from "../../Widgets/AnchorMenu.js";
import { TableContainerWithTabs, TableContainer, SectionContainer } from "../../Widgets/Container.js";
import { coverImageUrlOption } from "../../Shared/Image.js";
import { Skeleton } from "../../Components/Skeleton.js";
import { ChangelogTable } from "../../Widgets/Tables/ChangelogTable.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, initViewConsumable } from "./State.js";

function allowsInAnyStorage(permissions, permission, userId, stockPerStorage) {
    if (isEmpty(stockPerStorage)) {
        return Permissions_has(permissions, permission);
    }
    else {
        return exists((sps) => Permissions_allowsInStorage(permissions, permission, userId, sps.StorageId, sps.AssignedUserIds), stockPerStorage);
    }
}

function AppointmentSection(props) {
    const t = useTranslation()[0];
    const permissions = usePermissions();
    const canCreateReminder = allowsInAnyStorage(permissions, new Permission(19, []), props.UserData.UserId, props.Consumable.StockPerStorage);
    const canUpdateReminder = Permissions_has(permissions, new Permission(20, []));
    const canDeleteReminder = Permissions_has(permissions, new Permission(21, []));
    const patternInput_1 = reactApi.useState(false);
    const setIsReminderDialogOpen = patternInput_1[1];
    const patternInput_2 = reactApi.useState(undefined);
    const setSelectedReminderToConfirm = patternInput_2[1];
    const selectedReminderToConfirm = patternInput_2[0];
    const patternInput_3 = reactApi.useState(false);
    const setIsModalOpen = patternInput_3[1];
    const patternInput_4 = reactApi.useState(undefined);
    const setSelectedReminder = patternInput_4[1];
    const selectedReminder = patternInput_4[0];
    const patternInput_5 = reactApi.useState(undefined);
    const setSelectedDeleteReminder = patternInput_5[1];
    const selectedDeleteReminder = patternInput_5[0];
    const now = date_1(utcNow());
    const reminders = sortByDescending((r) => r.Date, props.Consumable.Reminders, {
        Compare: (x, y) => (compare(x, y) | 0),
    });
    const xs_3 = toList(delay(() => append(singleton(createElement(NewReminder_OpenDialog, {
        ConsumableId: new ConsumableId_1(parse(props.Consumable.Id)),
        IsOpen: patternInput_1[0],
        OnClose: () => {
            setIsReminderDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(3, []));
        },
    })), delay(() => {
        let IsOpen;
        return append(singleton(createElement(EditReminder_OpenDialog, (IsOpen = (selectedReminder != null), {
            ConsumableId: new ConsumableId_1(parse(props.Consumable.Id)),
            IsOpen: IsOpen,
            OnClose: () => {
                setSelectedReminder(undefined);
            },
            Reminder: unwrap(selectedReminder),
            SuccessCallback: () => {
                props.Dispatch(new Msg(3, []));
            },
        }))), delay(() => {
            let matchValue, reminder;
            return append((matchValue = selectedReminderToConfirm, (matchValue == null) ? (empty()) : ((reminder = matchValue, append(singleton(createElement(ConfirmDialog_ConfirmReminderDialog, {
                ConsumableId: new ConsumableId_1(parse(props.Consumable.Id)),
                IsOpen: selectedReminderToConfirm != null,
                OnClose: () => {
                    setSelectedReminderToConfirm(undefined);
                },
                Reminder: reminder,
                SuccessCallback: (isFileUploaded) => {
                    props.Dispatch(new Msg(3, []));
                    if (isFileUploaded) {
                        props.Dispatch(new Msg(20, []));
                    }
                },
            })), delay(() => singleton(defaultOf())))))), delay(() => {
                let IsOpen_1;
                return append((selectedDeleteReminder != null) ? singleton(createElement(DeleteReminder_OpenDialog, (IsOpen_1 = (selectedDeleteReminder != null), {
                    ConsumableId: new ConsumableId_1(parse(props.Consumable.Id)),
                    IsOpen: IsOpen_1,
                    OnClose: () => {
                        setSelectedDeleteReminder(undefined);
                    },
                    Reminder: unwrap(selectedDeleteReminder),
                    SuccessCallback: () => {
                        props.Dispatch(new Msg(3, []));
                        props.Dispatch(new Msg(20, []));
                    },
                }))) : empty(), delay(() => {
                    let elems_2;
                    const table = (rows) => {
                        let TableRows, Options;
                        return createElement(Table, (TableRows = toArray(rows), (Options = {
                            BorderStyle: "row",
                            CSVDownload: false,
                            ConfigurableColumns: false,
                            CustomTableFilters: false,
                            DefaultSortColumn: ["date", "desc"],
                            Fullscreen: false,
                            GlobalSearch: false,
                            RowSelection: "singleRow",
                            SaveTableConfiguration: false,
                        }, {
                            ColumnDefinitions: [new ColumnDefinition$1("state", "", t("general.done"), (reminderDate) => {
                                let elems;
                                return reminderDate.IsConfirmed ? (new CellContent(2, [createElement(ColoredDot, {
                                    Color: "green",
                                })])) : ((compare(reminderDate.Date, now) > 0) ? (new CellContent(2, [createElement(ColoredDot, {
                                    Color: "orange",
                                })])) : (new CellContent(2, [reactElement("div", createObj(ofArray([["className", join(" ", ["text-red", "h-5", "w-5"])], (elems = [Calendar_Warning()], ["children", reactApi.Children.toArray(Array.from(elems))])])))])));
                            }, "none", "text"), new ColumnDefinition$1("date", "", t("general.planned_date"), (dto) => (new CellContent(8, [dto.Date])), "dateRange", "date"), new ColumnDefinition$1("executionDate", "", t("general.execution_date"), (dto_1) => (new CellContent(8, [dto_1.ExecutionDate])), "dateRange", "date"), new ColumnDefinition$1("name", "", t("general.name"), (dto_2) => (new CellContent(0, [dto_2.Title])), "none", "text"), new ColumnDefinition$1("description", "", t("general.description"), (dto_3) => (new CellContent(0, [dto_3.Description])), "none", "text"), new ColumnDefinition$1("comment", "", t("general.comment"), (dto_4) => (new CellContent(0, [dto_4.ConfirmationComment])), "none", "text"), new ColumnDefinition$1("hasDocumentLinked", "", t("document_reminder_relation.documents_link"), (dto_5) => (new CellContent(2, [createElement(Modal_OpenLinkedDocumentModalButtonModalSheet, {
                                Documents: filter((doc) => contains(DocumentId__get_unwrap(doc.Id), dto_5.DocumentIds, {
                                    Equals: (x_1, y_1) => (x_1 === y_1),
                                    GetHashCode: (x_1) => (stringHash(x_1) | 0),
                                }), props.Documents),
                                LinkedEntityId: new FileDialog_LinkedEntityId(0, [dto_5.Id]),
                                OnClose: () => {
                                    props.Dispatch(new Msg(20, []));
                                    props.Dispatch(new Msg(3, []));
                                },
                                UploadType: new FileDialog_LinkedDocumentToolType(1, [new ConsumableId_1(parse(props.Consumable.Id))]),
                                UserData: props.UserData,
                            })])), "none", "text"), new ColumnDefinition$1("changelog-history", "", t(""), (dto_6) => (new CellContent(2, [createElement(OpenChangelogButtonModalSheet, {
                                EntityId: dto_6.Id,
                            })])), "none", "button")],
                            Controls: toList(delay(() => append((isFeatureEnabled(new Feature(12, [])) && canCreateReminder) ? singleton(new TableControl$1(t("dialog.reminder.btn_title"), Calendar_Add(), (_arg_8) => {
                                setIsReminderDialogOpen(true);
                            }, false, false, "table-reminder")) : empty(), delay(() => append(canUpdateReminder ? singleton(new TableControl$1(t("general.edit"), Pencil(), (rows_1) => {
                                const matchValue_1 = tryHead(rows_1);
                                if (matchValue_1 == null) {
                                }
                                else {
                                    setSelectedReminder(matchValue_1);
                                }
                            }, true, false, "table-edit")) : empty(), delay(() => append(canUpdateReminder ? singleton(new TableControl$1(t("general.mark_as_done"), Check(), (rows_2) => {
                                const matchValue_2 = tryHead(rows_2);
                                if (matchValue_2 != null) {
                                    setSelectedReminderToConfirm(matchValue_2);
                                }
                            }, true, false, "table-mark-as-done")) : empty(), delay(() => (canDeleteReminder ? singleton(new TableControl$1(t("general.delete"), Recycle_Bin_1(), (rows_3) => {
                                const matchValue_3 = tryHead(rows_3);
                                if (matchValue_3 == null) {
                                }
                                else {
                                    setSelectedDeleteReminder(matchValue_3);
                                }
                            }, true, false, "table-delete")) : empty()))))))))),
                            Options: Options,
                            TableKey: "not-defined-table",
                            TableRows: TableRows,
                        })));
                    };
                    return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_2 = toList(delay(() => append(singleton(table((length(reminders) > 5) ? take(5, reminders) : reminders)), delay(() => {
                        let elems_1;
                        return (length(reminders) > 5) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems_1 = [createElement(Button, {
                            ComponentState: "enabled",
                            Label: t("general.show_more_data"),
                            OnClick: () => {
                                setIsModalOpen(true);
                            },
                            TestId: "consumable-reminder-showmoredata-button",
                            Variant: "blueButton",
                        }), createElement(ModalSheet, {
                            CloseButtonTestId: "",
                            Content: table(reminders),
                            Controls: empty_1(),
                            IsModalOpen: patternInput_3[0],
                            OnClose: () => {
                                setIsModalOpen(false);
                            },
                            Title: t("general.appointments"),
                        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))) : empty();
                    })))), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
                }));
            }));
        }));
    }))));
    return react.createElement(react.Fragment, {}, ...xs_3);
}

function ReservationSection(props) {
    const t = useTranslation()[0];
    const permissions = usePermissions();
    const allowsReservation = (permission, reservation_1) => Permissions_allowsObject(permissions, permission, props.UserData.UserId, map((sps_1) => (new StorageAccess(sps_1.StorageId, sps_1.AssignedUserIds)), tryFind((sps) => (sps.StorageName === reservation_1.StorageName), props.Consumable.StockPerStorage)), reservation_1.SenderInformation.ReceiverId);
    const patternInput_1 = reactApi.useState(false);
    const setIsModalOpen = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const setIsReservationDialogOpen = patternInput_2[1];
    const patternInput_3 = reactApi.useState(undefined);
    const setSelectedReservation = patternInput_3[1];
    const selectedReservation = patternInput_3[0];
    const patternInput_4 = reactApi.useState(undefined);
    const setSelectedDeleteReservation = patternInput_4[1];
    const selectedDeleteReservation = patternInput_4[0];
    const reservations = sortByDescending((r) => r.StartDate, props.Consumable.Reservations, {
        Compare: (x, y) => (compare(x, y) | 0),
    });
    const xs_2 = toList(delay(() => append(singleton(createElement(NewReservation_NewConsumableReservationDialog, {
        Consumable: props.Consumable,
        IsOpen: patternInput_2[0],
        OnClose: () => {
            setIsReservationDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(3, []));
        },
        UserData: props.UserData,
    })), delay(() => {
        let matchValue, reservation_2, IsOpen;
        return append((matchValue = selectedReservation, (matchValue == null) ? (empty()) : ((reservation_2 = matchValue, singleton(createElement(EditConsumableReservationDialog, (IsOpen = (selectedReservation != null), {
            ConsumableId: new ConsumableId_1(parse(props.Consumable.Id)),
            IsOpen: IsOpen,
            OnClose: () => {
                setSelectedReservation(undefined);
            },
            ReservationId: reservation_2.Id,
            SuccessCallback: () => {
                props.Dispatch(new Msg(3, []));
            },
            UserData: props.UserData,
        })))))), delay(() => append((selectedDeleteReservation != null) ? singleton(createElement(DeleteConsumableReservationDialog, {
            Consumable: props.Consumable,
            IsOpen: selectedDeleteReservation != null,
            OnClose: () => {
                setSelectedDeleteReservation(undefined);
            },
            Reservation: unwrap(selectedDeleteReservation),
            SuccessCallback: () => {
                props.Dispatch(new Msg(3, []));
            },
            UserData: props.UserData,
        })) : empty(), delay(() => {
            let elems_1;
            const table = (rows) => {
                let TableRows, Options;
                return createElement(Table, (TableRows = toArray(rows), (Options = {
                    BorderStyle: "row",
                    CSVDownload: false,
                    ConfigurableColumns: false,
                    CustomTableFilters: false,
                    DefaultSortColumn: ["startDate", "asc"],
                    Fullscreen: false,
                    GlobalSearch: false,
                    RowSelection: "singleRow",
                    SaveTableConfiguration: false,
                }, {
                    ColumnDefinitions: [new ColumnDefinition$1("startDate", "", t("general.start_date"), (dto) => (new CellContent(8, [dto.StartDate])), "dateRange", "date"), new ColumnDefinition$1("endDate", "", t("general.end_date"), (dto_1) => (new CellContent(8, [dto_1.EndDate])), "dateRange", "date"), new ColumnDefinition$1("receiverName", "", t("general.receiver"), (dto_2) => (new CellContent(0, [dto_2.ReceiverInformation.ReceiverName])), "none", "text"), new ColumnDefinition$1("quantity", "", t("general.quantity"), (dto_3) => (new CellContent(0, [dto_3.Quantity.toString()])), "text", "text"), new ColumnDefinition$1("storage", "", t("general.storage"), (dto_4) => (new CellContent(0, [dto_4.StorageName])), "select", "text"), new ColumnDefinition$1("reservationName", "", t("general.name"), (dto_5) => (new CellContent(0, [dto_5.Name])), "none", "text"), new ColumnDefinition$1("description", "", t("general.description"), (dto_6) => (new CellContent(0, [dto_6.Description])), "none", "text"), new ColumnDefinition$1("sender", "", t("general.created_by"), (dto_7) => (new CellContent(0, [dto_7.SenderInformation.SenderName])), "none", "text"), new ColumnDefinition$1("changelog-history", "", t(""), (dto_8) => (new CellContent(2, [createElement(OpenChangelogButtonModalSheet, {
                        EntityId: dto_8.Id,
                    })])), "none", "button")],
                    Controls: toList(delay(() => append((isFeatureEnabled(new Feature(12, [])) && Permissions_has(permissions, new Permission(11, []))) ? singleton(new TableControl$1(t("dialog.reservation.btn_title"), Calendar_Add(), (_arg_6) => {
                        setIsReservationDialogOpen(true);
                    }, false, false, "table-reservation")) : empty(), delay(() => append(Permissions_has(permissions, new Permission(12, [])) ? singleton(new TableControl$1(t("general.edit"), Pencil(), (rows_1) => {
                        const matchValue_1 = tryHead(rows_1);
                        if (matchValue_1 == null) {
                        }
                        else {
                            const planning = matchValue_1;
                            if (allowsReservation(new Permission(12, []), planning)) {
                                setSelectedReservation(planning);
                            }
                        }
                    }, true, false, "table-edit")) : empty(), delay(() => (Permissions_has(permissions, new Permission(13, [])) ? singleton(new TableControl$1(t("general.delete"), Recycle_Bin_1(), (rows_2) => {
                        const matchValue_2 = tryHead(rows_2);
                        if (matchValue_2 == null) {
                        }
                        else {
                            const planning_1 = matchValue_2;
                            if (allowsReservation(new Permission(13, []), planning_1)) {
                                setSelectedDeleteReservation(planning_1);
                            }
                        }
                    }, true, false, "table-delete")) : empty()))))))),
                    Options: Options,
                    TableKey: "not-defined-table",
                    TableRows: TableRows,
                })));
            };
            return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_1 = toList(delay(() => append(singleton(table((length(reservations) > 5) ? take(5, reservations) : reservations)), delay(() => {
                let elems;
                return (length(reservations) > 5) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems = [createElement(Button, {
                    ComponentState: "enabled",
                    Label: t("general.show_more_data"),
                    OnClick: () => {
                        setIsModalOpen(true);
                    },
                    TestId: "consumable-reservations-showmoredata-button",
                    Variant: "blueButton",
                }), createElement(ModalSheet, {
                    CloseButtonTestId: "",
                    Content: table(reservations),
                    Controls: empty_1(),
                    IsModalOpen: patternInput_1[0],
                    OnClose: () => {
                        setIsModalOpen(false);
                    },
                    Title: t("navbar.reservation"),
                })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
            })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
        }))));
    }))));
    return react.createElement(react.Fragment, {}, ...xs_2);
}

export function OverviewInformationSection(props) {
    let elems_12;
    const t = useTranslation()[0];
    const currentState = resolve(useDefinitions(), props.Consumable.StateKey, ofConsumableState(props.Consumable.State));
    const countOfUnits = sum(map_1((stockPerStorage_1) => stockPerStorage_1.Stock, filter((stockPerStorage) => stockPerStorage.IsStockTrackingEnabled, props.Consumable.StockPerStorage)), {
        GetZero: () => 0,
        Add: (x, y) => (x + y),
    });
    const countOfUntisString = replace(countOfUnits.toString(), ".", ",");
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "ml-5"])], (elems_12 = toList(delay(() => append(singleton(reactElement("div", {
        className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
        children: t("general.state"),
    })), delay(() => {
        let elems_1, elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["mr-1"])], (elems = [createElement(StateDot, {
            Definition: currentState,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(TextValue, {
            FontWeight: "normal",
            TestId: "inventory-state-text",
            Text: stateText(t, currentState, props.Consumable.StateDate),
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
            let elems_2;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["min-w-full", "text-sm", "font-semibold", "mb-2"])], (elems_2 = [t("general.name")], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => append(singleton(reactElement("div", {
                className: join(" ", ["mb-2"]),
                children: reactApi.Children.toArray([props.Consumable.MasterData.Name]),
            })), delay(() => {
                let matchValue, businessUnitName, elems_4;
                return append(isFeatureEnabled(new Feature(17, [])) ? (props.AccountSettings.BusinessUnitsEnabled ? ((matchValue = props.Consumable.BusinessUnitName, (matchValue == null) ? (empty()) : ((businessUnitName = matchValue, append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["min-w-full", "text-sm", "font-semibold", "mb-2"])], (elems_4 = [t("business_units.business_unit")], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))), delay(() => singleton(reactElement("div", {
                    className: join(" ", ["mb-2"]),
                    children: reactApi.Children.toArray([businessUnitName]),
                })))))))) : empty()) : empty(), delay(() => {
                    let elems_6;
                    return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["min-w-full", "text-sm", "font-semibold", "mb-2"])], (elems_6 = [t("general.stock")], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))), delay(() => {
                        let elems_8, elems_7;
                        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], (elems_8 = [reactElement("div", createObj(ofArray([["className", join(" ", ["mr-1"])], (elems_7 = [createElement(ColoredDot, {
                            Color: (countOfUnits === 0) ? "red" : "green",
                        })], ["children", reactApi.Children.toArray(Array.from(elems_7))])]))), createElement(TextValue, {
                            FontWeight: "normal",
                            TestId: "",
                            Text: concat(countOfUntisString, " ", ...t(Helper_unitToTranslationKey(props.Consumable.Unit))),
                        })], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))), delay(() => {
                            let matchValue_1, lastSeen, elems_10, elems_9;
                            return append((matchValue_1 = props.Consumable.LastSeen, (matchValue_1 == null) ? (empty()) : ((lastSeen = matchValue_1, singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_10 = [reactElement("div", {
                                className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
                                children: t("general.last_seen"),
                            }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], (elems_9 = [createElement(TextValue, {
                                FontWeight: "normal",
                                TestId: "",
                                Text: `${toString(toLocalTime(lastSeen.ScannedAt), "dd.MM.yyyy HH:mm")} ${t("general.last_seen_by")} ${lastSeen.ScannedByUserName} (${(lastSeen.ScanMethod === "nfc_tag") ? t("general.nfc_tag") : t("general.qr_code")})`,
                            })], ["children", reactApi.Children.toArray(Array.from(elems_9))])])))], ["children", reactApi.Children.toArray(Array.from(elems_10))])]))))))), delay(() => {
                                let elems_11, Label, Label_1, Label_2, Label_3, Value_3;
                                return isFeatureEnabled(new Feature(3, [])) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_11 = [createElement(QuickOverviewList, {
                                    Currency: props.CustomerConfiguration.Currency,
                                    Elements: {
                                        CommercialData: unwrap(props.Consumable.CommercialData),
                                        Custom: ofArray([(Label = t("consumable.additional_name"), {
                                            Group: t("general.master_data"),
                                            Key: "consumable-additional-name-fav-field",
                                            Label: Label,
                                            Value: props.Consumable.MasterData.AdditionalName,
                                        }), (Label_1 = t("general.description"), {
                                            Group: t("general.master_data"),
                                            Key: "consumable-description-fav-field",
                                            Label: Label_1,
                                            Value: props.Consumable.MasterData.Description,
                                        }), (Label_2 = t("general.inventory_number"), {
                                            Group: t("general.master_data"),
                                            Key: "consumable-inventorynumber-fav-field",
                                            Label: Label_2,
                                            Value: props.Consumable.MasterData.InventoryNumber,
                                        }), (Label_3 = t("general.unit"), (Value_3 = t(Helper_unitToTranslationKey(props.Consumable.Unit)), {
                                            Group: t("general.master_data"),
                                            Key: "consumable-unit-fav-field",
                                            Label: Label_3,
                                            Value: Value_3,
                                        }))]),
                                        CustomProperties: props.Consumable.CustomProperties,
                                    },
                                    FormState: props.QuickOverviewDialog.FormState,
                                    IsDialogOpen: props.QuickOverviewDialog.IsOpen,
                                    OnSave: (updatedVisibleKeys) => {
                                        props.Dispatch(new Msg(0, [updatedVisibleKeys]));
                                    },
                                    SetDialogOpen: (_arg) => {
                                        props.Dispatch(new Msg(2, []));
                                    },
                                    UserData: props.UserData,
                                    VisibleKeys: props.UserConfiguration.QuickOverviewConfiguration.ConsumableViewVisibleFieldKeys,
                                })], ["children", reactApi.Children.toArray(Array.from(elems_11))])])))) : empty();
                            }));
                        }));
                    }));
                }));
            }))));
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_12))])])));
}

export function OverviewSection(props) {
    let elems_6;
    const t = useTranslation()[0];
    const permissions = usePermissions();
    const assignedUserIds = collect((sps) => sps.AssignedUserIds, props.Consumable.StockPerStorage);
    const canAssign = Permissions_allowsBooking(permissions, new Permission(6, []), props.UserData.UserId, assignedUserIds, false);
    const canReturn = Permissions_allowsBooking(permissions, new Permission(7, []), props.UserData.UserId, assignedUserIds, false);
    const canChangeState = allowsInAnyStorage(permissions, new Permission(4, []), props.UserData.UserId, props.Consumable.StockPerStorage);
    const canEditImages = allowsInAnyStorage(permissions, new Permission(27, []), props.UserData.UserId, props.Consumable.StockPerStorage);
    const definitions = useDefinitions();
    const currentState = resolve(definitions, props.Consumable.StateKey, ofConsumableState(props.Consumable.State));
    const allows = (action) => allows_1(action, currentState);
    const patternInput_1 = reactApi.useState(false);
    const setIsAssignDialogOpen = patternInput_1[1];
    const isAssignDialogOpen = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const setIsUnassignDialogOpen = patternInput_2[1];
    const isUnassignDialogOpen = patternInput_2[0];
    const patternInput_3 = reactApi.useState(undefined);
    const setSelectedTarget = patternInput_3[1];
    const patternInput_4 = reactApi.useState(false);
    const setIsReturnNotificationDialogOpen = patternInput_4[1];
    const isReturnNotificationDialogOpen = patternInput_4[0];
    const patternInput_5 = reactApi.useState(false);
    const setIsSelfServiceAssignDialogOpen = patternInput_5[1];
    const isSelfServiceAssignDialogOpen = patternInput_5[0];
    const patternInput_6 = reactApi.useState(false);
    const setIsSelfServiceReturnDialogOpen = patternInput_6[1];
    const isSelfServiceReturnDialogOpen = patternInput_6[0];
    const patternInput_7 = reactApi.useState(false);
    const setIsStartProcedureDialogOpen = patternInput_7[1];
    const isStartProcedureDialogOpen = patternInput_7[0];
    const actionButtons = toList(delay(() => {
        let Label;
        return append((canAssign && allows(new InventoryAction(0, []))) ? singleton(createElement(TextButton, (Label = t("general.assign"), {
            ComponentState: "enabled",
            Icon: Following(),
            Label: Label,
            OnClick: () => {
                setIsAssignDialogOpen(true);
            },
            TestId: "consumable-overview-assign-button",
            Variant: "default",
        }))) : empty(), delay(() => {
            let Label_1;
            return (canReturn && allows(new InventoryAction(3, []))) ? singleton(createElement(TextButton, (Label_1 = t("general.take_back"), {
                ComponentState: "enabled",
                Icon: Followers(),
                Label: Label_1,
                OnClick: () => {
                    setIsUnassignDialogOpen(true);
                },
                TestId: "consumable-overview-unassign-button",
                Variant: "default",
            }))) : empty();
        }));
    }));
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "grow"])], (elems_6 = toList(delay(() => append(isStartProcedureDialogOpen ? singleton(createElement(StartProcedureDialog, {
        EntityReference: new ProcedureEntityReferenceDto(2, [props.Consumable.Id]),
        IsOpen: isStartProcedureDialogOpen,
        LabelIds: map_1((c) => parse(c.CategoryId), props.Consumable.Categories),
        OnClose: () => {
            setIsStartProcedureDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(3, []));
        },
    })) : empty(), delay(() => append(isAssignDialogOpen ? singleton(createElement(AssignConsumableDialog, {
        Consumable: props.Consumable,
        IsOpen: isAssignDialogOpen,
        OnClose: () => {
            setIsAssignDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(3, []));
        },
        UserId: props.UserData.UserId,
    })) : empty(), delay(() => append(isUnassignDialogOpen ? singleton(createElement(UnassignConsumableDialog, {
        ConsumableId: props.Consumable.Id,
        IsOpen: isUnassignDialogOpen,
        OnClose: () => {
            setIsUnassignDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(3, []));
        },
        UserData: props.UserData,
    })) : empty(), delay(() => append(isReturnNotificationDialogOpen ? singleton(createElement(ReturnConsumableNotificationDialog, {
        Consumable: props.Consumable,
        IsOpen: isReturnNotificationDialogOpen,
        OnClose: () => {
            setIsReturnNotificationDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(3, []));
        },
        UserId: props.UserData.UserId,
    })) : empty(), delay(() => append(isSelfServiceAssignDialogOpen ? singleton(createElement(SelfServiceAssignConsumableDialog, {
        Consumable: props.Consumable,
        IsOpen: isSelfServiceAssignDialogOpen,
        OnClose: () => {
            setIsSelfServiceAssignDialogOpen(false);
        },
        SelfServiceStorages: filter((sps_1) => {
            if (props.CustomerConfiguration.GlobalSelfServiceStorageActive) {
                return true;
            }
            else {
                return exists((s) => {
                    if (unwrapStorageId(s.Id) === sps_1.StorageId) {
                        if (s.IsSelfService) {
                            return true;
                        }
                        else {
                            return contains(props.UserData.UserId, s.AccessByUser, {
                                Equals: (x, y) => (x === y),
                                GetHashCode: (x) => (stringHash(x) | 0),
                            });
                        }
                    }
                    else {
                        return false;
                    }
                }, props.Storages);
            }
        }, props.Consumable.StockPerStorage),
        SuccessCallback: () => {
            props.Dispatch(new Msg(3, []));
        },
        UserId: props.UserData.UserId,
    })) : empty(), delay(() => append(isSelfServiceReturnDialogOpen ? singleton(createElement(SelfServiceReturnConsumableDialog, {
        Consumable: props.Consumable,
        IsOpen: isSelfServiceReturnDialogOpen,
        OnClose: () => {
            setIsSelfServiceReturnDialogOpen(false);
        },
        SelfServiceStorages: filter((sps_2) => {
            if (props.CustomerConfiguration.GlobalSelfServiceStorageActive) {
                return true;
            }
            else {
                return exists((s_1) => {
                    if (unwrapStorageId(s_1.Id) === sps_2.StorageId) {
                        if (s_1.IsSelfService) {
                            return true;
                        }
                        else {
                            return contains(props.UserData.UserId, s_1.AccessByUser, {
                                Equals: (x_1, y_1) => (x_1 === y_1),
                                GetHashCode: (x_1) => (stringHash(x_1) | 0),
                            });
                        }
                    }
                    else {
                        return false;
                    }
                }, props.Storages);
            }
        }, props.Consumable.StockPerStorage),
        SuccessCallback: () => {
            props.Dispatch(new Msg(3, []));
        },
        UserId: props.UserData.UserId,
    })) : empty(), delay(() => {
        let elems_5, elems_2, elems, elems_1, elems_4, elems_3;
        return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "pt-8", "pb-10", "rounded", "px-12"])], (elems_5 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-between", "mb-12"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-4"])], (elems = toList(delay(() => {
            let Label_2;
            if (canAssign ? true : canReturn) {
                return actionButtons;
            }
            else {
                const isSelfServiceUser = props.CustomerConfiguration.GlobalSelfServiceStorageActive ? true : exists((s_2) => {
                    if (exists((sps_3) => (sps_3.StorageId === unwrapStorageId(s_2.Id)), props.Consumable.StockPerStorage)) {
                        if (s_2.IsSelfService) {
                            return true;
                        }
                        else {
                            return contains(props.UserData.UserId, s_2.AccessByUser, {
                                Equals: (x_2, y_2) => (x_2 === y_2),
                                GetHashCode: (x_2) => (stringHash(x_2) | 0),
                            });
                        }
                    }
                    else {
                        return false;
                    }
                }, props.Storages);
                const canSelfServiceAssign = Permissions_allowsBooking(permissions, new Permission(6, []), props.UserData.UserId, assignedUserIds, isSelfServiceUser);
                const canSelfServiceReturn = Permissions_allowsBooking(permissions, new Permission(7, []), props.UserData.UserId, assignedUserIds, isSelfServiceUser);
                return append((canSelfServiceAssign && allows(new InventoryAction(0, []))) ? ((sumBy((sps_4) => sps_4.Stock, props.Consumable.StockPerStorage, {
                    GetZero: () => 0,
                    Add: (x_3, y_3) => (x_3 + y_3),
                }) > 0) ? singleton(createElement(TextButton, (Label_2 = t("general.self_service_assign"), {
                    ComponentState: "enabled",
                    Icon: Following(),
                    Label: Label_2,
                    OnClick: () => {
                        setIsSelfServiceAssignDialogOpen(true);
                    },
                    TestId: "consumable-detail-self-service-assign-button",
                    Variant: "default",
                }))) : empty()) : empty(), delay(() => {
                    let Label_3, Label_4;
                    return (allows(new InventoryAction(3, [])) ? true : allows(new InventoryAction(2, []))) ? (((canSelfServiceReturn && allows(new InventoryAction(3, []))) && props.CustomerConfiguration.IsStorageSelfServiceUserAuthorisedToReturnToolsWithoutNotification) ? singleton(createElement(TextButton, (Label_3 = t("general.self_service_return"), {
                        ComponentState: "enabled",
                        Icon: Followers(),
                        Label: Label_3,
                        OnClick: () => {
                            setIsSelfServiceReturnDialogOpen(true);
                        },
                        TestId: "consumable-detail-self-service-return-button",
                        Variant: "default",
                    }))) : ((Permissions_has(permissions, new Permission(7, [])) && allows(new InventoryAction(2, []))) ? singleton(createElement(TextButton, (Label_4 = t("general.request_return"), {
                        ComponentState: "enabled",
                        Icon: Followers(),
                        Label: Label_4,
                        OnClick: () => {
                            setIsReturnNotificationDialogOpen(true);
                        },
                        TestId: "consumable-detail-return-notification-button",
                        Variant: "default",
                    }))) : empty())) : empty();
                }));
            }
        })), ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "gap-4", "items-center"])], (elems_1 = toList(delay(() => {
            let matchValue;
            return append((matchValue = patternInput_3[0], (matchValue == null) ? (empty()) : singleton(createElement(StateChangeDialog, {
                Consumable: props.Consumable,
                IsOpen: true,
                OnClose: () => {
                    setSelectedTarget(undefined);
                },
                SuccessCallback: () => {
                    props.Dispatch(new Msg(3, []));
                },
                Target: matchValue,
            }))), delay(() => {
                let Label_5;
                return append((props.HasManualHooks && allows(new InventoryAction(7, []))) ? singleton(createElement(TextButton, (Label_5 = t("procedure.manual_start.button"), {
                    ComponentState: "enabled",
                    Icon: Order_History(),
                    Label: Label_5,
                    OnClick: () => {
                        setIsStartProcedureDialogOpen(true);
                    },
                    TestId: "consumable-detail-start-procedure-button",
                    Variant: "default",
                }))) : empty(), delay(() => {
                    const statusElements = map_1((target_1) => {
                        const Icon_6 = targetIcon(target_1);
                        return {
                            DisplayName: targetLabel(t, target_1),
                            Icon: unwrap(Icon_6),
                            OnClick: () => {
                                setSelectedTarget(target_1);
                            },
                        };
                    }, targets(props.AccountSettings, new InventoryKind(3, []), currentState, definitions));
                    return (canChangeState && !isEmpty(statusElements)) ? singleton(createElement(TextDropdownButton, {
                        Classes: empty_1(),
                        ComponentState: "enabled",
                        DisplayArrow: true,
                        DisplayDivider: false,
                        Elements: statusElements,
                        Label: t("general.change_status"),
                        TestId: "consumable-detail-change-status-dropdown",
                    })) : empty();
                }));
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), createElement(NotificationArea, {
            IsCurrentUserStorageResponsible: canReturn,
            NotificationToolType: new NotificationToolType_1(3, []),
            Notifications: props.Notifications,
            OnUpdate: () => {
                props.Dispatch(new Msg(3, []));
            },
            UserData: props.UserData,
        }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "gap-x-16", "gap-y-6", "mb-8"])], (elems_4 = [reactElement("div", createObj(ofArray([["className", join(" ", ["max-w-full"])], (elems_3 = [createElement(MultipleImageWidget, {
            CanEditImage: canEditImages,
            ComponentState: props.ImagesFormState.IsLoading ? "disabled" : "enabled",
            FormImages: props.ConsumableImages,
            Images: map_1((image) => ({
                ImageUrl: image.ImageUrl,
                Position: image.Position,
            }), props.Consumable.ConsumableImages),
            OnImagesChanged: (images) => {
                props.Dispatch(new Msg(7, [images]));
            },
            OnSave: () => {
                props.Dispatch(new Msg(8, []));
            },
        })], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), createElement(OverviewInformationSection, {
            AccountSettings: props.AccountSettings,
            Consumable: props.Consumable,
            CustomerConfiguration: props.CustomerConfiguration,
            Dispatch: props.Dispatch,
            QuickOverviewDialog: props.QuickOverviewDialog,
            UserConfiguration: props.UserConfiguration,
            UserData: props.UserData,
        })], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))));
    })))))))))))))), ["children", reactApi.Children.toArray(Array.from(elems_6))])])));
}

export function MasterDataSection(props) {
    let elems_4, elems_3;
    const t = useTranslation()[0];
    return reactElement("div", createObj(singleton_1((elems_4 = [reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-2", "gap-20", "h-30"])], (elems_3 = toList(delay(() => {
        let elems_1, Title, elems;
        return append(singleton(reactElement("div", createObj(singleton_1((elems_1 = [createElement(PropertyList, (Title = t("general.master_data"), {
            Properties: ofArray([{
                Label: t("general.name"),
                TestId: "master-data-name",
                Value: props.Consumable.MasterData.Name,
            }, {
                Label: t("consumable.additional_name"),
                TestId: "master-data-additional-name",
                Value: props.Consumable.MasterData.AdditionalName,
            }, {
                Label: t("general.description"),
                TestId: "master-data-description",
                Value: props.Consumable.MasterData.Description,
            }, {
                Label: t("general.inventory_number"),
                TestId: "master-data-inventory-number",
                Value: props.Consumable.MasterData.InventoryNumber,
            }, {
                Label: t("general.unit"),
                TestId: "master-data-unit",
                Value: t(Helper_unitToTranslationKey(props.Consumable.Unit)),
            }]),
            Title: unwrap(Title),
        })), reactElement("div", createObj(ofArray([["className", join(" ", ["mt-8"])], (elems = [createElement(CustomPropertiesPropertyList, {
            Currency: props.Currency,
            CustomProperties: props.Consumable.CustomProperties,
            Title: t("tool.custom_properties"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))]))))), delay(() => {
            let elems_2, Title_2, matchValue_1, matchValue_2, matchValue_3;
            const matchValue = props.Consumable.CommercialData;
            if (matchValue == null) {
                return empty();
            }
            else {
                const commercialData = matchValue;
                return singleton(reactElement("div", createObj(singleton_1((elems_2 = [createElement(PropertyList, (Title_2 = t("general.commercial_data"), {
                    Properties: ofArray([{
                        Label: t("general.supplier"),
                        TestId: "commercial-data-supplier",
                        Value: commercialData.Supplier,
                    }, {
                        Label: t("general.supplier_article_number"),
                        TestId: "commercial-data-supplier-article-number",
                        Value: commercialData.SupplierArticleNumber,
                    }, {
                        Label: t("general.purchase_price"),
                        TestId: "commercial-data-purchase-price",
                        Value: (matchValue_1 = commercialData.PurchasePrice, (matchValue_1 == null) ? "" : priceToString(matchValue_1, props.Currency)),
                    }, {
                        Label: t("general.purchase_date"),
                        TestId: "commercial-data-purchase-date",
                        Value: (matchValue_2 = commercialData.PurchaseDate, (matchValue_2 == null) ? "" : toString(matchValue_2, "dd.MM.yyyy")),
                    }, {
                        Label: t("general.gurantee_date"),
                        TestId: "commercial-data-guarantee-date",
                        Value: (matchValue_3 = commercialData.WarrantyDate, (matchValue_3 == null) ? "" : toString(matchValue_3, "dd.MM.yyyy")),
                    }, {
                        Label: t("general.comment"),
                        TestId: "commercial-data-comment",
                        Value: commercialData.Comment,
                    }]),
                    Title: unwrap(Title_2),
                }))], ["children", reactApi.Children.toArray(Array.from(elems_2))])))));
            }
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))]))));
}

function DocumentSection(props) {
    let elems_1;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsModalOpen = patternInput_1[1];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_1 = toList(delay(() => {
        let Documents;
        return append(singleton(createElement(DocumentTable, (Documents = ((length(props.Documents) > 5) ? take(5, props.Documents) : props.Documents), {
            AdditionalColumns: singleton_1(new ColumnDefinition$1("changelog-history", "", t(""), (dto) => (new CellContent(2, [createElement(OpenChangelogButtonModalSheet, {
                EntityId: DocumentId__get_unwrap(dto.Id),
            })])), "none", "button")),
            Documents: Documents,
            OnDownloadFile: (tupledArg) => {
                props.Dispatch(new Msg(21, [tupledArg[0], tupledArg[1]]));
            },
            UploadSuccessCallback: () => {
                props.Dispatch(new Msg(20, []));
            },
            UploadType: new UploadType_2(1, [props.ConsumableId]),
            UserData: props.UserData,
        }))), delay(() => {
            let elems, Title;
            return (length(props.Documents) > 5) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems = [createElement(Button, {
                ComponentState: "enabled",
                Label: t("general.show_more_data"),
                OnClick: () => {
                    setIsModalOpen(true);
                },
                TestId: "tool-selectcard-tooldetail-showmoredata-button",
                Variant: "blueButton",
            }), createElement(ModalSheet, (Title = t("general.documents"), {
                CloseButtonTestId: "",
                Content: createElement(DocumentTable, {
                    AdditionalColumns: singleton_1(new ColumnDefinition$1("changelog-history", "", t(""), (dto_1) => (new CellContent(2, [createElement(OpenChangelogButtonModalSheet, {
                        EntityId: DocumentId__get_unwrap(dto_1.Id),
                    })])), "none", "button")),
                    Documents: props.Documents,
                    OnDownloadFile: (tupledArg_1) => {
                        props.Dispatch(new Msg(21, [tupledArg_1[0], tupledArg_1[1]]));
                    },
                    UploadSuccessCallback: () => {
                        props.Dispatch(new Msg(20, []));
                    },
                    UploadType: new UploadType_2(1, [props.ConsumableId]),
                    UserData: props.UserData,
                }),
                Controls: empty_1(),
                IsModalOpen: patternInput_1[0],
                OnClose: () => {
                    setIsModalOpen(false);
                },
                Title: unwrap(Title),
            }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function HistorySection(props) {
    let elems_1;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsHistoryModalOpen = patternInput_1[1];
    const patternInput_2 = reactApi.useState(undefined);
    const setAssignmentProtocolParams = patternInput_2[1];
    const table = (rows) => {
        let TableRows;
        return createElement(Table, (TableRows = toArray(rows), {
            ColumnDefinitions: [new ColumnDefinition$1("timestamp", "", t("general.date"), (dto) => (new CellContent(9, [dto.Timestamp])), "none", "dateTime"), new ColumnDefinition$1("eventType", "", t("general.event"), (dto_1) => (new CellContent(0, [defaultArg(dto_1.StateName, t(Helper_historyTypeToTranslationString(dto_1.EventType)))])), "select", "text"), new ColumnDefinition$1("quantity", "", t("general.quantity"), (dto_2) => (new CellContent(0, [dto_2.Quantity.toString()])), "text", "text"), new ColumnDefinition$1("commission", "", t("general.commission"), (dto_3) => (new CellContent(0, [dto_3.CommissionNumber])), "text", "text"), new ColumnDefinition$1("comment", "", t("general.comment"), (dto_4) => {
                const matchValue = dto_4.Event;
                return (matchValue == null) ? (new CellContent(0, [t(dto_4.Comment)])) : (new CellContent(0, [Helper_displayHistoryComment(t(matchValue), dto_4.Comment)]));
            }, "none", "text"), new ColumnDefinition$1("receiver", "", t("general.receiver"), (dto_5) => {
                let matchValue_1;
                return new CellContent(0, [(matchValue_1 = dto_5.ReceiverInformation, (matchValue_1 == null) ? "" : matchValue_1.Name)]);
            }, "text", "text"), new ColumnDefinition$1("sender", "", t("general.sender"), (dto_6) => (new CellContent(0, [dto_6.SenderInformation.Name])), "text", "text"), new ColumnDefinition$1("signatureUrl", "", t("general.signature"), (dto_7) => {
                let matchValue_2;
                return new CellContent(6, [(matchValue_2 = dto_7.ReceiverInformation, (matchValue_2 != null) ? defaultArg(map((x) => x, matchValue_2.SignatureUrl), "") : "")]);
            }, "none", "image"), new ColumnDefinition$1("storage", "", t("general.storage"), (dto_8) => (new CellContent(0, [defaultArg(map((storage) => storage.Name, dto_8.StorageInformation), "")])), "text", "text"), new ColumnDefinition$1("action", "", "", (dto_9) => {
                const matchValue_3 = dto_9.EventType;
                switch (matchValue_3) {
                    case "updatedStock":
                    case "updatedStorage":
                    case "stocktakingStorageCorrectionBooking":
                    case "changeInformation":
                    case "activate":
                    case "retire":
                        return new CellContent(0, [""]);
                    case "procedureCompleted":
                    case "procedureCancelled": {
                        const matchValue_5 = dto_9.ProcedureId;
                        if (matchValue_5 == null) {
                            return new CellContent(0, [""]);
                        }
                        else {
                            const procedureId = matchValue_5;
                            return new CellContent(3, [t("procedure.view_results"), () => {
                                RouterModule_nav(ofArray(["procedures", procedureId, "results"]), 1, 1);
                            }]);
                        }
                    }
                    default:
                        return new CellContent(3, [t("assignment_protocol.open_assignment_protocol"), () => {
                            let AssignmentType, ReceiverName, StorageName, SignatureUrl, ImageUrl, EntityImageUrl;
                            setAssignmentProtocolParams((AssignmentType = t(Helper_historyTypeToTranslationString(dto_9.EventType)), (ReceiverName = defaultArg(map((_arg_1) => _arg_1.Name, dto_9.ReceiverInformation), ""), (StorageName = map((_arg_2) => _arg_2.Name, dto_9.StorageInformation), (SignatureUrl = flatten(map((_arg_3) => _arg_3.SignatureUrl, dto_9.ReceiverInformation)), (ImageUrl = ((props.BusinessUnitImageUrl == null) ? props.CustomerConfiguration.ProtocolConfiguration.ImageUrl : props.BusinessUnitImageUrl), (EntityImageUrl = (props.CustomerConfiguration.ProtocolConfiguration.ProtocolVisibleFields.EntityImage ? props.EntityImageUrl : undefined), new AssignmentProtocolParams(AssignmentType, props.ConsumableName, props.InventoryNumber, dto_9.SenderInformation.Name, ReceiverName, props.CustomerConfiguration.ProtocolConfiguration.ProtocolVisibleFields.QrCodeIds ? (isEmpty(props.QrCodeIds) ? "" : reduce((list_1, code) => concat(list_1, ", ", ...code), props.QrCodeIds)) : undefined, StorageName, dto_9.Comment, undefined, SignatureUrl, dto_9.Timestamp, ImageUrl, EntityImageUrl, dto_9.SenderImageUrls, dto_9.ReceiverImageUrls))))))));
                        }]);
                }
            }, "none", "text")],
            Controls: empty_1(),
            Options: {
                BorderStyle: "row",
                CSVDownload: true,
                ConfigurableColumns: false,
                CustomTableFilters: false,
                DefaultSortColumn: ["timestamp", "desc"],
                Fullscreen: false,
                GlobalSearch: false,
                RowSelection: "disabled",
                SaveTableConfiguration: false,
            },
            TableKey: "not-defined-table",
            TableRows: TableRows,
        }));
    };
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_1 = toList(delay(() => append(singleton(createElement(AssignmentProtocolDialog, {
        AssignmentProtocolParams: unwrap(patternInput_2[0]),
        OnClose: () => {
            setAssignmentProtocolParams(undefined);
        },
    })), delay(() => append(singleton(table((length(props.HistoryRows) > 5) ? take(5, props.HistoryRows) : props.HistoryRows)), delay(() => {
        let elems;
        return (length(props.HistoryRows) > 5) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems = [createElement(Button, {
            ComponentState: "enabled",
            Label: t("general.show_more_data"),
            OnClick: () => {
                setIsHistoryModalOpen(true);
            },
            TestId: "consumable-masterdata-showmoredata-button",
            Variant: "blueButton",
        }), createElement(ModalSheet, {
            CloseButtonTestId: "",
            Content: table(props.HistoryRows),
            Controls: empty_1(),
            IsModalOpen: patternInput_1[0],
            OnClose: () => {
                setIsHistoryModalOpen(false);
            },
            Title: t("history.title"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
    })))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function StockSection(props) {
    let elems;
    const t = useTranslation()[0];
    const permissions = usePermissions();
    const responsibleStorageIds = map_1((storage_1) => unwrapStorageId(storage_1.Id), filter((storage) => Permissions_allowsInStorage(permissions, new Permission(5, []), props.UserData.UserId, unwrapStorageId(storage.Id), storage.AssignedUserIds), props.Storages));
    const gated = (action, control) => {
        if (allows_1(action, props.CurrentState)) {
            return singleton_1(control);
        }
        else {
            return empty_1();
        }
    };
    const containsStorageId = (storageId) => contains(storageId, responsibleStorageIds, {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    });
    const patternInput_1 = reactApi.useState(undefined);
    const setIsDeleteStockPerStorageDialogOpen = patternInput_1[1];
    const isDeleteStockPerStorageDialogOpen = patternInput_1[0];
    const patternInput_2 = reactApi.useState(undefined);
    const setIsMinimumStockQuantityDialogOpen = patternInput_2[1];
    const isMinimumStockQuantityDialogOpen = patternInput_2[0];
    const patternInput_3 = reactApi.useState(undefined);
    const setIsStockChangeDialogOpen = patternInput_3[1];
    const patternInput_4 = reactApi.useState(undefined);
    const setIsChangeStorageSpaceDialogOpen = patternInput_4[1];
    const isChangeStorageSpaceDialogOpen = patternInput_4[0];
    const patternInput_5 = reactApi.useState(undefined);
    const setIsChangeStorageDialogOpen = patternInput_5[1];
    const isChangeStorageDialogOpen = patternInput_5[0];
    const patternInput_6 = reactApi.useState(false);
    const setIsStockAddDialogOpen = patternInput_6[1];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems = toList(delay(() => {
        let matchValue_6, selectedStorage, matchValue_7, selectedStorage_2;
        return append((matchValue_6 = patternInput_3[0], (matchValue_6 == null) ? (empty()) : ((selectedStorage = matchValue_6, (matchValue_7 = selectedStorage[1], (matchValue_7 == null) ? (empty()) : ((selectedStorage_2 = matchValue_7, singleton(createElement(ChangeStockDialog, {
            ConsumableId: new ConsumableId_1(parse(props.Consumable.Id)),
            IsOpen: selectedStorage[0],
            OnClose: () => {
                setIsStockChangeDialogOpen(undefined);
            },
            StorageId: selectedStorage_2,
            Storages: filter((storage_2) => containsStorageId(unwrapStorageId(storage_2.Id)), props.Storages),
            SuccessCallback: () => {
                props.Dispatch(new Msg(3, []));
            },
        })))))))), delay(() => append(singleton(createElement(StockAddDialog, {
            ConsumableId: new ConsumableId_1(parse(props.Consumable.Id)),
            IsOpen: patternInput_6[0],
            OnClose: () => {
                setIsStockAddDialogOpen(false);
            },
            Storages: filter((storage_3) => containsStorageId(unwrapStorageId(storage_3.Id)), props.Storages),
            SuccessCallback: () => {
                props.Dispatch(new Msg(3, []));
            },
        })), delay(() => {
            let matchValue_8, selectedStorageSpace, selectedStorage_3, IsOpen;
            return append((matchValue_8 = isChangeStorageSpaceDialogOpen, (matchValue_8 == null) ? (empty()) : ((selectedStorageSpace = matchValue_8[0], (selectedStorage_3 = matchValue_8[1], singleton(createElement(ChangeStorageSpaceDialog, (IsOpen = (isChangeStorageSpaceDialogOpen != null), {
                ConsumableId: new ConsumableId_1(parse(props.Consumable.Id)),
                IsEditableForUser: true,
                IsOpen: IsOpen,
                OnClose: () => {
                    setIsChangeStorageSpaceDialogOpen(undefined);
                },
                StorageId: new StorageId_2(parse(selectedStorage_3)),
                StorageSpace: selectedStorageSpace,
                SuccessCallback: () => {
                    props.Dispatch(new Msg(3, []));
                },
            }))))))), delay(() => {
                let matchValue_9;
                return append((matchValue_9 = isChangeStorageDialogOpen, (matchValue_9 == null) ? (empty()) : singleton(createElement(SwitchStorageDialog, {
                    Consumable: props.Consumable,
                    IsOpen: isChangeStorageDialogOpen != null,
                    OnClose: () => {
                        setIsChangeStorageDialogOpen(undefined);
                    },
                    SelectedSourceStorageId: matchValue_9,
                    Storages: filter((storage_4) => containsStorageId(unwrapStorageId(storage_4.Id)), props.Storages),
                    SuccessCallback: () => {
                        props.Dispatch(new Msg(3, []));
                    },
                    UserId: props.UserData.UserId,
                }))), delay(() => {
                    let matchValue_10, selectedStorage_4, IsOpen_2;
                    return append((matchValue_10 = isMinimumStockQuantityDialogOpen, (matchValue_10 == null) ? (empty()) : ((selectedStorage_4 = matchValue_10, singleton(createElement(MinimumStockQuantityDialog, (IsOpen_2 = (isMinimumStockQuantityDialogOpen != null), {
                        ConsumableId: new ConsumableId_1(parse(props.Consumable.Id)),
                        IsOpen: IsOpen_2,
                        OnClose: () => {
                            setIsMinimumStockQuantityDialogOpen(undefined);
                        },
                        StorageId: selectedStorage_4,
                        SuccessCallback: () => {
                            props.Dispatch(new Msg(3, []));
                        },
                    })))))), delay(() => {
                        let matchValue_11, selectedStorage_5, IsOpen_3;
                        return append((matchValue_11 = isDeleteStockPerStorageDialogOpen, (matchValue_11 == null) ? (empty()) : ((selectedStorage_5 = matchValue_11, singleton(createElement(ConsumablesStockPerStorageDeleteDialog, (IsOpen_3 = (isDeleteStockPerStorageDialogOpen != null), {
                            ConsumableId: new ConsumableId_1(parse(props.Consumable.Id)),
                            IsOpen: IsOpen_3,
                            OnClose: () => {
                                setIsDeleteStockPerStorageDialogOpen(undefined);
                            },
                            StorageId: selectedStorage_5,
                            SuccessCallback: () => {
                                props.Dispatch(new Msg(3, []));
                            },
                        })))))), delay(() => {
                            let TableRows, Options;
                            return singleton(createElement(Table, (TableRows = toArray(props.Consumable.StockPerStorage), (Options = {
                                BorderStyle: "row",
                                CSVDownload: false,
                                ConfigurableColumns: false,
                                CustomTableFilters: false,
                                DefaultSortColumn: ["storage", "asc"],
                                Fullscreen: false,
                                GlobalSearch: false,
                                RowSelection: "singleRow",
                                SaveTableConfiguration: false,
                            }, {
                                ColumnDefinitions: [new ColumnDefinition$1("storage", "", t("general.storage"), (dto) => (new CellContent(0, [dto.StorageName])), "none", "text"), new ColumnDefinition$1("location", "", t("consumable.storage_space"), (dto_1) => (new CellContent(0, [t(dto_1.StorageSpace)])), "none", "text"), new ColumnDefinition$1("storageLocation", "", t("general.location"), (dto_2) => (new CellContent(0, [defaultArg(map((_arg) => _arg.Name, dto_2.Location), "–")])), "none", "text"), new ColumnDefinition$1("isStockTrackingEnabled", "", t("consumable.stock_tracking_enabled"), (dto_3) => (dto_3.IsStockTrackingEnabled ? (new CellContent(0, [t("general.yes")])) : (new CellContent(0, [t("general.no")]))), "none", "text"), new ColumnDefinition$1("quantity", "", t("general.stock"), (dto_4) => (!dto_4.IsStockTrackingEnabled ? (new CellContent(0, [""])) : (new CellContent(0, [dto_4.Stock.toString()]))), "none", "text"), new ColumnDefinition$1("minimum_quantity", "", t("general.minimum_quantity"), (dto_5) => {
                                    if (!dto_5.IsStockTrackingEnabled) {
                                        return new CellContent(0, [""]);
                                    }
                                    else {
                                        const matchValue = dto_5.MinimumStockQuantity;
                                        if (matchValue != null) {
                                            const minimumstockQuantity = matchValue;
                                            return new CellContent(0, [minimumstockQuantity.toString()]);
                                        }
                                        else {
                                            return new CellContent(0, [""]);
                                        }
                                    }
                                }, "none", "text"), new ColumnDefinition$1("qrcode", "", t("general.qr_code"), (dto_6) => (new CellContent(0, [isEmpty(dto_6.QRCodeIds) ? "" : reduce((e1, e2) => concat(e1, ", ", ...e2), map_1((e) => e, dto_6.QRCodeIds))])), "none", "text")],
                                Controls: isEmpty(responsibleStorageIds) ? empty_1() : toList(delay(() => append(gated(new InventoryAction(11, []), new TableControl$1(t("consumable.dialogs.stock_add_dialog.title"), Warehouse_1(), (_arg_1) => {
                                    setIsStockAddDialogOpen(true);
                                }, false, false, "consumable-detail-stock-add")), delay(() => append(gated(new InventoryAction(11, []), new TableControl$1(t("tool.update_stock"), Warehouse_1(), (selectedSps) => {
                                    if (isEmpty(selectedSps)) {
                                        setIsStockChangeDialogOpen([true, undefined]);
                                    }
                                    else {
                                        const matchValue_1 = tryHead(map_1((selectedTool) => selectedTool.StorageId, selectedSps));
                                        if (matchValue_1 == null) {
                                        }
                                        else {
                                            const selectedStorageId_1 = matchValue_1;
                                            if (containsStorageId(selectedStorageId_1)) {
                                                setIsStockChangeDialogOpen([true, new StorageId_2(parse(selectedStorageId_1))]);
                                            }
                                        }
                                    }
                                }, true, false, "consumable-detail-update-stock")), delay(() => append(gated(new InventoryAction(11, []), new TableControl$1(t("tool.change_storage_space"), Location_Building_Search(), (selectedSps_1) => {
                                    if (isEmpty(selectedSps_1)) {
                                    }
                                    else {
                                        const matchValue_2 = tryHead(map_1((selectedTool_1) => [selectedTool_1.StorageSpace, selectedTool_1.StorageId], selectedSps_1));
                                        if (matchValue_2 == null) {
                                        }
                                        else {
                                            const selectedStorageId_3 = matchValue_2;
                                            if (containsStorageId(selectedStorageId_3[1])) {
                                                setIsChangeStorageSpaceDialogOpen(selectedStorageId_3);
                                            }
                                        }
                                    }
                                }, true, false, "consumable-detail-change-storage-space")), delay(() => append(gated(new InventoryAction(4, []), new TableControl$1(t("tool.switch_storage"), Transfer_Cart(), (selectedSps_2) => {
                                    if (isEmpty(selectedSps_2)) {
                                    }
                                    else {
                                        const matchValue_3 = tryHead(map_1((selectedStockPerStorage) => selectedStockPerStorage.StorageId, selectedSps_2));
                                        if (matchValue_3 == null) {
                                        }
                                        else {
                                            const selectedStorageId_5 = matchValue_3;
                                            if (containsStorageId(selectedStorageId_5)) {
                                                setIsChangeStorageDialogOpen(selectedStorageId_5);
                                            }
                                        }
                                    }
                                }, false, false, "consumable-detail-switch-storage")), delay(() => append(gated(new InventoryAction(11, []), new TableControl$1(t("general.minimum_quantity_update"), Notification_Alarm_1(), (selectedSps_3) => {
                                    if (isEmpty(selectedSps_3)) {
                                    }
                                    else {
                                        const matchValue_4 = tryHead(map_1((selectedTool_2) => selectedTool_2.StorageId, selectedSps_3));
                                        if (matchValue_4 == null) {
                                        }
                                        else {
                                            const selectedStorageId_7 = matchValue_4;
                                            if (containsStorageId(selectedStorageId_7)) {
                                                setIsMinimumStockQuantityDialogOpen(new StorageId_2(parse(selectedStorageId_7)));
                                            }
                                        }
                                    }
                                }, true, false, "consumable-detail-minimum-quantity-update")), delay(() => singleton(new TableControl$1(t("general.delete"), Recycle_Bin_1(), (selectedSps_4) => {
                                    if (isEmpty(selectedSps_4)) {
                                    }
                                    else {
                                        const matchValue_5 = tryHead(map_1((selectedTool_3) => selectedTool_3.StorageId, selectedSps_4));
                                        if (matchValue_5 == null) {
                                        }
                                        else {
                                            const selectedStorageId_9 = matchValue_5;
                                            if (containsStorageId(selectedStorageId_9)) {
                                                setIsDeleteStockPerStorageDialogOpen(new StorageId_2(parse(selectedStorageId_9)));
                                            }
                                        }
                                    }
                                }, true, false, "consumable-detail-delete-storage")))))))))))))),
                                Options: Options,
                                TableKey: "not-defined-table",
                                TableRows: TableRows,
                            }))));
                        }));
                    }));
                }));
            }));
        }))));
    })), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function BarcodeSection(props) {
    let elems_1;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsModalOpen = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const setIsPrintLabelOpen = patternInput_2[1];
    const onPrintLabel = printLabelControl(props.PrintLabel, () => {
        setIsPrintLabelOpen(true);
    });
    let tableData;
    const list_6 = collect((x) => x, map_1((stockPerStorage) => choose((qrCodeId) => {
        let StorageId;
        return (StorageId = (new StorageId_2(parse(stockPerStorage.StorageId))), {
            AssignedUserIds: stockPerStorage.AssignedUserIds,
            Location: defaultArg(map((_arg) => _arg.Name, stockPerStorage.Location), "–"),
            QrCode: qrCodeId,
            StorageId: StorageId,
            StorageName: stockPerStorage.StorageName,
            StorageSpace: stockPerStorage.StorageSpace,
        });
    }, stockPerStorage.QRCodeIds), props.StockPerStorage));
    tableData = append_1(choose((stockPerStorage_2) => {
        let StorageId_1;
        return (StorageId_1 = (new StorageId_2(parse(stockPerStorage_2.StorageId))), {
            AssignedUserIds: stockPerStorage_2.AssignedUserIds,
            Location: defaultArg(map((_arg_1) => _arg_1.Name, stockPerStorage_2.Location), "–"),
            QrCode: "",
            StorageId: StorageId_1,
            StorageName: stockPerStorage_2.StorageName,
            StorageSpace: stockPerStorage_2.StorageSpace,
        });
    }, filter((stockPerStorage_1) => isEmpty(stockPerStorage_1.QRCodeIds), props.StockPerStorage)), list_6);
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_1 = toList(delay(() => append(singleton(createElement(PrintLabelDialogFor, {
        IsOpen: patternInput_2[0],
        OnClose: () => {
            setIsPrintLabelOpen(false);
        },
        Options: props.PrintLabel,
    })), delay(() => append(singleton(createElement(QrCodeTableWithStorage, {
        Data: (length(tableData) > 5) ? take(5, tableData) : tableData,
        OnAssignQrCode: (tupledArg) => {
            props.Dispatch(new Msg(12, [tupledArg[0], tupledArg[1]]));
        },
        OnDeleteQrCodes: (tupledArg_1) => {
            props.Dispatch(new Msg(14, [tupledArg_1[0], tupledArg_1[1]]));
        },
        OnPrintLabel: unwrap(onPrintLabel),
        UserData: props.UserData,
    })), delay(() => {
        let elems, Title;
        return (length(tableData) > 5) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems = [createElement(Button, {
            ComponentState: "enabled",
            Label: t("general.show_more_data"),
            OnClick: () => {
                setIsModalOpen(true);
            },
            TestId: "tool-selectcard-tooldetail-showmoredata-button",
            Variant: "blueButton",
        }), createElement(ModalSheet, (Title = t("general.qr_code"), {
            CloseButtonTestId: "",
            Content: createElement(QrCodeTableWithStorage, {
                Data: tableData,
                OnAssignQrCode: (value_4) => {
                },
                OnDeleteQrCodes: (value_5) => {
                },
                OnPrintLabel: unwrap(onPrintLabel),
                UserData: props.UserData,
            }),
            Controls: empty_1(),
            IsModalOpen: patternInput_1[0],
            OnClose: () => {
                setIsModalOpen(false);
            },
            Title: unwrap(Title),
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
    })))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function ConsumableDetailOverview(props) {
    let elems_14, elems_13, elems, cats, elems_1, elems_12, elems_11;
    const t = useTranslation()[0];
    const permissions = usePermissions();
    const currentState = resolve(useDefinitions(), props.Consumable.StateKey, ofConsumableState(props.Consumable.State));
    const canDelete = allowsInAnyStorage(permissions, new Permission(3, []), props.UserData.UserId, props.Consumable.StockPerStorage);
    const canCreate = allowsInAnyStorage(permissions, new Permission(1, []), props.UserData.UserId, props.Consumable.StockPerStorage);
    const canUpdate = allowsInAnyStorage(permissions, new Permission(2, []), props.UserData.UserId, props.Consumable.StockPerStorage) && allows_1(new InventoryAction(11, []), currentState);
    const canReadHistory = allowsInAnyStorage(permissions, new Permission(32, []), props.UserData.UserId, props.Consumable.StockPerStorage);
    const canReadStocktakings = canReadStocktakingHistory(permissions, props.AccountSettings);
    const canReadReminders = allowsInAnyStorage(permissions, new Permission(18, []), props.UserData.UserId, props.Consumable.StockPerStorage);
    const patternInput_1 = reactApi.useState(false);
    const setIsDeleteDialogOpen = patternInput_1[1];
    const isDeleteDialogOpen = patternInput_1[0];
    const patternInput_2 = reactApi.useState("consumable-overview-section");
    const printLabel = new PrintLabelOptions(new LabelInventoryKind(3, []), props.Consumable.Id, props.CustomerConfiguration, allowsInAnyStorage(permissions, new Permission(24, []), props.UserData.UserId, props.Consumable.StockPerStorage), allowsInAnyStorage(permissions, new Permission(22, []), props.UserData.UserId, props.Consumable.StockPerStorage), () => {
        props.Dispatch(new Msg(3, []));
    });
    const children = reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "grow", "flex-col"])], (elems_14 = [createElement(ConsumableDeleteDialog, {
        ConsumableId: new ConsumableId_1(parse(props.Consumable.Id)),
        IsOpen: isDeleteDialogOpen,
        OnClose: () => {
            setIsDeleteDialogOpen(false);
        },
        SuccessCallback: () => {
            RouterModule_nav(ofArray(["consumables"]), 1, 1);
        },
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-[10rem,minmax(0,80rem)]", "print:flex", "print:flex-col"])], (elems_13 = [reactElement("div", createObj(ofArray([["className", join(" ", ["col-span-2"])], (elems = [createElement(DetailViewHeader, {
        Badges: (cats = props.Consumable.Categories, map_1((leaf) => createElement(Badge, {
            Color: leaf.ColorHex,
            Label: join(" > ", ofArray(split(leaf.CategoryName, [" > "], undefined, 0))),
            TestId: concat("category-badge-", ...leaf.CategoryId),
        }), filter((c) => !exists((o) => {
            if (o.CategoryName !== c.CategoryName) {
                return o.CategoryName.startsWith(c.CategoryName + " > ");
            }
            else {
                return false;
            }
        }, cats), cats))),
        OnBack: () => {
            RouterModule_nav(singleton_1("consumables" + RouterModule_encodeQueryString(getQueryParams(undefined))), 1, 1);
        },
        OnDelete: unwrap(canDelete ? (() => {
            setIsDeleteDialogOpen(!isDeleteDialogOpen);
        }) : undefined),
        OnDuplicate: unwrap(canCreate ? (() => {
            RouterModule_nav(ofArray(["consumables", props.Consumable.Id, "copy" + RouterModule_encodeQueryString(getQueryParams(undefined))]), 1, 1);
        }) : undefined),
        OnEdit: unwrap(canUpdate ? (() => {
            RouterModule_nav(ofArray(["consumables", props.Consumable.Id, "edit" + RouterModule_encodeQueryString(getQueryParams(undefined))]), 1, 1);
        }) : undefined),
        Title: props.Consumable.MasterData.Name,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["print:hidden"])], (elems_1 = [createElement(AreaAnchorMenu, {
        Anchors: toList(delay(() => append(singleton({
            Id: "consumable-overview-section",
            Label: t("general.overview"),
        }), delay(() => append(singleton({
            Id: "consumable-masterdata-section",
            Label: t("general.master_data"),
        }), delay(() => append((isFeatureEnabled(new Feature(12, [])) && canReadReminders) ? append(singleton({
            Id: "appointments-section-id",
            Label: t("general.appointments"),
        }), delay(() => singleton({
            Id: "reservations-section-id",
            Label: t("navbar.reservation"),
        }))) : empty(), delay(() => append(singleton({
            Id: "consumable-stock-section",
            Label: t("general.stock"),
        }), delay(() => append(singleton({
            Id: "consumable-documents-section",
            Label: t("general.documents"),
        }), delay(() => append(singleton({
            Id: "barcodes-section-id",
            Label: t("general.qr_code"),
        }), delay(() => append(canReadStocktakings ? singleton({
            Id: "stocktakings-section-id",
            Label: t("stocktaking.history.title"),
        }) : empty(), delay(() => (canReadHistory ? singleton({
            Id: "history-section-id",
            Label: t("general.history"),
        }) : empty()))))))))))))))))),
        OnSelectAnchor: patternInput_2[1],
        SelectedAnchor: patternInput_2[0],
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", createObj(singleton_1((elems_12 = [reactElement("div", createObj(singleton_1((elems_11 = toList(delay(() => {
        let elems_2;
        return append(singleton(reactElement("div", createObj(ofArray([["id", "consumable-overview-section"], (elems_2 = [createElement(OverviewSection, {
            AccountSettings: props.AccountSettings,
            Consumable: props.Consumable,
            ConsumableImages: props.ConsumableImages,
            CustomerConfiguration: props.CustomerConfiguration,
            Dispatch: props.Dispatch,
            HasManualHooks: props.HasManualHooks,
            ImagesFormState: props.ImagesFormState,
            Notifications: props.Notifications,
            QuickOverviewDialog: props.QuickOverviewDialog,
            Storages: props.Storages,
            UserConfiguration: props.UserConfiguration,
            UserData: props.UserData,
        })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
            let elems_3, Title_1;
            return append(singleton(reactElement("section", createObj(ofArray([["id", "consumable-masterdata-section"], (elems_3 = [createElement(SectionContainer, (Title_1 = t("general.master_data"), {
                Content: createElement(MasterDataSection, {
                    AccountSettings: props.AccountSettings,
                    Consumable: props.Consumable,
                    Currency: props.CustomerConfiguration.Currency,
                }),
                Title: unwrap(Title_1),
            }))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => {
                let elems_4, Title_2;
                return append((isFeatureEnabled(new Feature(12, [])) && canReadReminders) ? singleton(reactElement("section", createObj(ofArray([["id", "appointments-section-id"], (elems_4 = [createElement(TableContainer, (Title_2 = t("general.appointments"), {
                    Content: createElement(AppointmentSection, {
                        Consumable: props.Consumable,
                        Dispatch: props.Dispatch,
                        Documents: props.Documents,
                        ReceiverNames: empty_1(),
                        UserData: props.UserData,
                    }),
                    Title: unwrap(Title_2),
                }))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))) : empty(), delay(() => {
                    let elems_5, Title_3;
                    return append(isFeatureEnabled(new Feature(12, [])) ? singleton(reactElement("section", createObj(ofArray([["id", "reservations-section-id"], (elems_5 = [createElement(TableContainer, (Title_3 = t("navbar.reservation"), {
                        Content: createElement(ReservationSection, {
                            Consumable: props.Consumable,
                            Dispatch: props.Dispatch,
                            ReceiverNames: empty_1(),
                            UserData: props.UserData,
                        }),
                        Title: unwrap(Title_3),
                    }))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))) : empty(), delay(() => {
                        let elems_6, Title_4;
                        return append(singleton(reactElement("section", createObj(ofArray([["id", "consumable-stock-section"], (elems_6 = [createElement(TableContainer, (Title_4 = t("general.stock"), {
                            Content: createElement(StockSection, {
                                Consumable: props.Consumable,
                                CurrentState: currentState,
                                Dispatch: props.Dispatch,
                                Storages: props.Storages,
                                UserData: props.UserData,
                            }),
                            Title: unwrap(Title_4),
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))), delay(() => {
                            let elems_7, Title_5;
                            return append(singleton(reactElement("section", createObj(ofArray([["id", "consumable-documents-section"], (elems_7 = [createElement(TableContainer, (Title_5 = t("general.documents"), {
                                Content: createElement(DocumentSection, {
                                    ConsumableId: new ConsumableId_1(parse(props.Consumable.Id)),
                                    Dispatch: props.Dispatch,
                                    Documents: props.Documents,
                                    IsVisibleForUser: true,
                                    UserData: props.UserData,
                                }),
                                Title: unwrap(Title_5),
                            }))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))), delay(() => {
                                let elems_8, Title_6;
                                return append(singleton(reactElement("section", createObj(ofArray([["id", "barcodes-section-id"], (elems_8 = [createElement(TableContainer, (Title_6 = t("general.qr_code"), {
                                    Content: createElement(BarcodeSection, {
                                        Dispatch: props.Dispatch,
                                        PrintLabel: printLabel,
                                        StockPerStorage: props.Consumable.StockPerStorage,
                                        Storages: props.Storages,
                                        UserData: props.UserData,
                                    }),
                                    Title: unwrap(Title_6),
                                }))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))), delay(() => {
                                    let elems_9, Title_7;
                                    return append(canReadStocktakings ? singleton(reactElement("section", createObj(ofArray([["id", "stocktakings-section-id"], (elems_9 = [createElement(TableContainer, (Title_7 = t("stocktaking.history.title"), {
                                        Content: createElement(InventoryStocktakingHistorySection, {
                                            Subject: new InventoryHistorySubject(1, [props.Consumable.Id]),
                                        }),
                                        Title: unwrap(Title_7),
                                    }))], ["children", reactApi.Children.toArray(Array.from(elems_9))])])))) : empty(), delay(() => {
                                        let elems_10, Title_8, Title_9, QrCodeIds, Title_10, matchValue;
                                        return canReadHistory ? singleton(reactElement("section", createObj(ofArray([["id", "history-section-id"], (elems_10 = [createElement(TableContainerWithTabs, (Title_8 = t("history.title"), {
                                            Tab1: (Title_9 = t("history.events"), {
                                                Content: createElement(HistorySection, (QrCodeIds = collect((x) => x, map_1((sps) => sps.QRCodeIds, props.Consumable.StockPerStorage)), {
                                                    BusinessUnitImageUrl: unwrap(props.BusinessUnitImageUrl),
                                                    ConsumableName: props.Consumable.MasterData.Name,
                                                    CustomerConfiguration: props.CustomerConfiguration,
                                                    EntityImageUrl: unwrap(coverImageUrlOption("", props.Consumable.ConsumableImages)),
                                                    HistoryRows: props.History,
                                                    InventoryNumber: props.Consumable.MasterData.InventoryNumber,
                                                    QrCodeIds: QrCodeIds,
                                                })),
                                                Title: Title_9,
                                            }),
                                            Tab2: (Title_10 = t("history.changes"), {
                                                Content: (matchValue = props.Changelogs, (matchValue.tag === 0) ? createElement(Skeleton, {
                                                    Variant: "table",
                                                }) : createElement(ChangelogTable, {
                                                    Changelogs: matchValue.fields[0],
                                                })),
                                                OnSelect: () => {
                                                    props.Dispatch(new Msg(30, []));
                                                },
                                                Title: Title_10,
                                            }),
                                            Title: unwrap(Title_8),
                                        }))], ["children", reactApi.Children.toArray(Array.from(elems_10))])])))) : empty();
                                    }));
                                }));
                            }));
                        }));
                    }));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_11))]))))], ["children", reactApi.Children.toArray(Array.from(elems_12))]))))], ["children", reactApi.Children.toArray(Array.from(elems_13))])])))], ["children", reactApi.Children.toArray(Array.from(elems_14))])])));
    return createElement(HistoryAccessProvider, {
        canReadHistory: canReadHistory,
        children: children,
    });
}

export function ConsumableDetailOverviewView(props) {
    let matchValue_10;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram((tupledArg) => initViewConsumable(tupledArg[0], tupledArg[1], tupledArg[2]), update_1, (_arg, _arg_1) => {
    }), [props.ConsumableId, props.UserData, usePermissions()], undefined);
    const state_1 = patternInput[0];
    const matchValue = state_1.Consumables;
    const matchValue_1 = state_1.History;
    const matchValue_2 = state_1.Documents;
    const matchValue_3 = state_1.UserConfiguration;
    const matchValue_4 = state_1.Storages;
    const matchValue_5 = state_1.Notifications;
    const matchValue_6 = state_1.CustomerConfiguration;
    const matchValue_7 = state_1.AccountSettings;
    const matchValue_8 = state_1.BusinessUnitImageUrl;
    let matchResult, accountSettings, businessUnitImageUrl, consumable, customerConfiguration, documents, history, notifications, storages, userConfiguration;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_3.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_4.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_5.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_6.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_7.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_8.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        accountSettings = matchValue_7.fields[0];
        businessUnitImageUrl = matchValue_8.fields[0];
        consumable = matchValue.fields[0];
        customerConfiguration = matchValue_6.fields[0];
        documents = matchValue_2.fields[0];
        history = matchValue_1.fields[0];
        notifications = matchValue_5.fields[0];
        storages = matchValue_4.fields[0];
        userConfiguration = matchValue_3.fields[0];
    }
    switch (matchResult) {
        case 0:
            return createElement(ConsumableDetailOverview, {
                AccountSettings: accountSettings,
                BusinessUnitImageUrl: unwrap(businessUnitImageUrl),
                Changelogs: state_1.Changelogs,
                Consumable: consumable,
                ConsumableImages: state_1.ConsumableImages,
                CustomerConfiguration: customerConfiguration,
                Dispatch: patternInput[1],
                Documents: documents,
                HasManualHooks: (matchValue_10 = state_1.ManualHooks, (matchValue_10.tag === 0) ? false : !isEmpty(matchValue_10.fields[0])),
                History: history,
                ImagesFormState: state_1.ImagesFormState,
                Notifications: notifications,
                QuickOverviewDialog: state_1.QuickOverviewDialog,
                Storages: storages,
                UserConfiguration: userConfiguration,
                UserData: state_1.UserData,
            });
        default:
            return createElement(Skeleton, {
                Variant: "detail",
            });
    }
}

